<template>
<div class="container-responsive">
  <div id="google-citation"></div>
  <div class="row terms-row" v-if="!getSecretAccessKey">
    <div class="col-4 offset-4 text-center">
      <terms></terms>
    </div>
  </div>
  <div class="row full-wrapper" v-if="populated">
    <image-modal ref="imageModal" v-bind:selectedImage="selectedImage" v-bind:photos="house.signedPhotos.large"></image-modal>
    <map-modal ref="mapModal" v-bind:location="house.loc()" v-bind:zoom="10" v-bind:addressPartOne="addressPartOne" v-bind:addressPartTwo="addressPartTwo"></map-modal>
    <share-modal ref="shareModal" v-bind:shareType="'House'" v-bind:typeData="shareData"></share-modal>
    <auth-modal ref="authModal"></auth-modal>
    <div class="col-xl-2 order-2 order-xl-1">
      <fact-sheet v-bind:originRoute="previousRoute" v-bind:searchString="searchString" v-bind:house="house"></fact-sheet>
    </div>
    <div class="col-xl-7 order-3 order-xl-2" v-if="endPath === 'info'">
      <home-profile-tabs v-if="houseClaimed" v-bind:uniqueId="house.id" v-bind:state="house.state" v-bind:publicProfile="true"></home-profile-tabs>
      <div class="row">
        <div class="col-lg-4">
          <div class="row content-wrapper">
            <table class="table table-borderless">
              <tbody>
                <tr v-if="house.listPriceStr()">
                  <td><h3>${{house.listPriceStr()}} <span class="house-status">{{ houseStatus }}</span></h3></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row content-wrapper">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <td><h4 v-if="house.bedroom_count">{{house.bedroom_count}} <i class="fas fa-bed"></i></h4></td>
                  <td><h4 v-if="house.bathroom_count">{{house.bathroom_count}} <i class="fas fa-bath"></i></h4></td>
                  <td><h4 v-if="house.house_sqft">{{house.house_sqft}} ft<sup>2</sup> <i class="fas fa-ruler-combined"></i></h4></td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="no-margin">
          <div class="row content-wrapper">
            <table class="table table-borderless">
              <tbody>
                <tr>
                  <td class="address">{{ addressPartOne }}<br>{{ addressPartTwo }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="no-margin">
          <div class="row content-wrapper">
            <table class="table table-borderless">
              <tbody>
                <tr v-if="house.pricePerSqft()">
                  <td>Price per Sqft:</td>
                  <td>${{ house.pricePerSqft() }}</td>
                </tr>
                <tr v-if="Number(house.lot_acres)">
                  <td>Lot Size:</td>
                  <td>{{ Number(house.lot_acres) }} Acres</td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr class="no-margin">
        </div>
        <div class="col-lg-8 order-1 order-lg-2 picture" v-bind:style="coverPhoto" v-on:click="showImageModal(0)">
          <house-tag v-bind:house="house"></house-tag>
          <div class="home-button">
            <img src="/static/Share.Yellow.svg" class="share-button" v-on:click.stop="copyURL" alt="Share Home">
          </div>
        </div>
      </div>
      <b-alert variant="success" dismissible fade v-bind:show="alertDismissCountdown" v-on:dismissed="alertDismissCountdown=0" v-on:alert-dismiss-countdown="alertCountdownChanged">Copied to clipboard</b-alert>
      <div class="row content-wrapper">
        <div class="col-8 pl-0">
          <table class="table table-borderless">
            <tbody>
              <tr v-if="house.style">
                <td>Property Type:</td>
                <td>{{house.style}}</td>
              </tr>
              <tr v-if="house.year_built">
                <td>Year Built:</td>
                <td>{{house.year_built}}</td>
              </tr>
              <tr v-if="house.hoa_fee">
                <td>HOA Fee:</td>
                <td>${{this.house.hoa_fee}}/{{this.house.hoa_fee_frequency}}</td>
              </tr>
              <span v-if="!offMarket">
                <tr v-if="house.download_time">
                  <td>Days on HomApt:</td>
                  <td>{{house.daysOnHomApt()}}</td>
                </tr>
                <tr>
                  <td><img class="broker-logo" src="../../../../static/brokerlogo.jpg"> Brokered By:</td>
                  <td>{{ house.brokerage }}</td>
                </tr>
              </span>
              <span v-else>
                <tr v-if="house.sold_date">
                  <td>Last Sold Date:</td>
                  <td>{{ new Intl.DateTimeFormat('en').format(new Date(house.sold_date)) }}</td>
                </tr>
                <tr v-if="house.tax_history.length">
                  <td>{{ house.tax_history[house.tax_history.length - 1].year }} Property Taxes:</td>
                  <td>{{ '$' + house.tax_history[house.tax_history.length - 1].tax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</td>
                </tr>
              </span>
              <tr v-if="house.agent">
                <td>Presented By: {{ house.agent }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-4 pr-0 map-container">
          <div id="neighborhood-map" v-on:click="showMapModal"></div>
        </div>
      </div>
      <hr class="no-margin">
      <div role="tablist">
        <div href="#" v-b-toggle.accordion-1 class="accordion-title">
          <h5 class="d-inline"><i v-if="propertyCollapse" class="fas fa-home"></i>Property Details</h5>
          <i v-if="!propertyCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="propertyCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-1" role="tabpanel" v-model="propertyCollapse">
          <property-details v-bind:house="house"></property-details>
        </b-collapse>
        <span v-if="!offMarket">
          <hr class="no-margin">
          <div href="#" v-b-toggle.accordion-2 class="accordion-title">
            <h5 class="d-inline">Open Houses</h5>
            <i v-if="!openHousesCollapse" class="fas fa-arrow-down float-right"></i>
            <i v-if="openHousesCollapse" class="fas fa-arrow-up float-right"></i>
          </div>
          <b-collapse id="accordion-2" role="tabpanel" v-model="openHousesCollapse">
            <open-houses v-bind:openHouses="house.open_houses"></open-houses>
          </b-collapse>
        </span>
        <hr class="no-margin">
        <div v-if="house.tax_history" href="#" v-b-toggle.accordion-3 class="accordion-title">
          <h5 class="d-inline">Tax History</h5>
          <i v-if="!taxHistoryCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="taxHistoryCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-3" v-if="house.tax_history" role="tabpanel" v-model="taxHistoryCollapse">
          <tax-history v-bind:taxHistory="house.tax_history"></tax-history>
        </b-collapse>
        <hr class="no-margin">
        <div v-if="house.price_history" href="#" v-b-toggle.accordion-4 class="accordion-title">
          <h5 class="d-inline">Property History</h5>
          <i v-if="!propertyHistoryCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="propertyHistoryCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-4" v-if="house.price_history" role="tabpanel" v-model="propertyHistoryCollapse">
          <property-history v-bind:propertyHistory="house.price_history"></property-history>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-5 class="accordion-title">
          <h5 class="d-inline">Nearby Schools</h5>
          <i v-if="!schoolsCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="schoolsCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-5" role="tabpanel" v-model="schoolsCollapse">
          <schools v-bind:loc="house.loc()"></schools>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-6 class="accordion-title">
          <h5 class="d-inline">Neighborhood</h5>
          <i v-if="!neighborhoodCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="neighborhoodCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-6" role="tabpanel" v-model="neighborhoodCollapse">
          <neighborhood v-bind:loc="house.loc()"></neighborhood>
        </b-collapse>
        <hr class="no-margin">
        <div href="#" v-b-toggle.accordion-7 class="accordion-title">
          <h5 class="d-inline">Disclosures</h5>
          <i v-if="!disclosureCollapse" class="fas fa-arrow-down float-right"></i>
          <i v-if="disclosureCollapse" class="fas fa-arrow-up float-right"></i>
        </div>
        <b-collapse id="accordion-7" role="tabpanel" v-model="disclosureCollapse">
          <disclosures></disclosures>
        </b-collapse>
        <hr class="no-margin">
      </div>
    </div>
    <div class="col-xl-7 order-3 order-xl-2" v-if="endPath === 'images'">
      <div class="card-columns">
        <div class="card" v-for="(image, index) in house.signedPhotos.medium" v-bind:key="index">
          <img class="card-img-top" v-bind:src="image" alt="Card image cap" v-on:click="showImageModal(index)">
        </div>
      </div>
    </div>
    <div v-if="!offMarket" class="col-xl-3 order-1 order-xl-3">
      <div class="form-inline">
        <div class="form-group">
          <div class="input-group">
            <input type="text" v-model="searchString" v-on:keydown.enter="changeURL" v-on:input="triggerSuggestions()" class="form-control form-filter-search" placeholder="Search">
            <div class="input-group-append form-filter-search-button" v-on:click="changeURL">
              <div class="input-group-text"><i class="fas fa-search"></i></div>
            </div>
          </div>
        </div>
        <house-suggestion-dropdown ref="suggestionDropdown" v-on:suggestionSearch="performSuggestionSearch"></house-suggestion-dropdown>
      </div>
      <schedule></schedule>
      <question v-bind:price="Number(house.price)"></question>
    </div>
    <div v-else class="col-xl-3 order-1 order-xl-3">
      <h2 class="homfax-title">HomFAX</h2>
      <p>HomApt HomFAX allows you to keep track of all maintenance and remodeling you do to your home.<br/>
         Why?<br/>
         ~ Track Home Value<br/>
         ~ Taxes<br/>
         ~ Seasonal Tips for Homeownership<br/>
         ~ Selling Maintenance Portfolio<br/>
         ~ Coupons from Vendors<br/>
         ~ Maintenance Reminders<br/>
         ~ DYI To Dos<br/>
      </p>
      <button class="btn btn-primary" v-on:click="showClaimModal">Claim</button>
      <claim-modal ref="claimModal" v-bind:house="house"></claim-modal>
      <hr>
      <h3>Thinking about Selling?</h3>
      <p>HomApt Realty will save you money with our 1.5% Listing Fee</p>
      <router-link to="/contact">
        <button class="btn btn-primary">Contact Agent</button>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import House from '../../../lib/mlsApi.js'
import router from '../../../router/index.js'
import VDaySelector from 'vuelendar/components/vl-day-selector'
import schools from './dropdowns/Schools.vue'
import neighborhood from './dropdowns/Neighborhood.vue'
import propertyDetails from './dropdowns/PropertyDetails.vue'
import openHouses from './dropdowns/OpenHouses.vue'
import taxHistory from './dropdowns/TaxHistory.vue'
import propertyHistory from './dropdowns/PropertyHistory.vue'
import disclosures from './dropdowns/Disclosures.vue'
import schedule from './rightSide/Schedule.vue'
import question from './rightSide/Question.vue'
import factSheet from './leftSide/FactSheet.vue'
import terms from '../homeSearch/rightSide/Terms.vue'
import imageModal from './ImageModal.vue'
import mapModal from './MapModal.vue'
import HouseTag from '../HouseTag.vue'
import SaveButton from '../../general/buttons/SaveHomeButton.vue'
import ShareModal from '../../general/modals/TheShareModal.vue'
import AuthModal from '../../authentication/TheAuthModal.vue'
import HouseSuggestionDropdown from '../homeSearch/searchBar/HouseSuggestionDropdown.vue'
import ClaimModal from './rightSide/ClaimModal.vue'
import HomeProfileTabs from './HomeProfileTabs.vue'

/* eslint-disable */
var houseSVG = ['<?xml version="1.0" encoding="utf-8"?>',
'<!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->',
'<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"',
        'x="0px" y="0px" viewBox="0 0 288 417" style="enable-background:new 0 0 288 417;" xml:space="preserve">',
'<style type="text/css">',
        '.st0{fill:#748096;}',
        '.st1{fill:#363E4A;}',
        '.st2{fill:#FCD990;}',
'</style>',
'<path class="st0" d="M105.5,277v112.4l26.5,23.7c5.7,5.1,18.3,5.1,24.1,0l26.5-23.7V277c-12.5,1.4-25.4,2.2-38.5,2.2',
        'S118,278.4,105.5,277z"/>',
'<circle class="st1" cx="144" cy="144" r="144"/>',
'<path class="st2" d="M140.8,89.9l-77.5,63.8v68.9c0,3.7,3,6.7,6.7,6.7l47.1-0.1c3.7,0,6.7-3,6.7-6.7v-40.2c0-3.7,3-6.7,6.7-6.7h26.9',
        'c3.7,0,6.7,3,6.7,6.7v40.2c0,3.7,3,6.7,6.7,6.7c0,0,0,0,0,0l47.1,0.1c3.7,0,6.7-3,6.7-6.7v-68.9l-77.4-63.7',
        'C145.3,88.4,142.7,88.4,140.8,89.9L140.8,89.9z M263.1,133.3L228,104.3V46.1c0-2.8-2.3-5-5-5h-23.5c-2.8,0-5,2.3-5,5v30.5',
        'l-37.6-30.9c-7.4-6.1-18.2-6.1-25.6,0L24.8,133.3c-2.1,1.8-2.4,5-0.7,7.1c0,0,0,0,0,0l10.7,13c1.8,2.2,4.9,2.5,7.1,0.7c0,0,0,0,0,0',
        'l98.8-81.4c1.9-1.5,4.6-1.5,6.4,0l98.8,81.4c2.1,1.8,5.3,1.5,7.1-0.7c0,0,0,0,0,0l10.7-13C265.6,138.2,265.3,135,263.1,133.3',
        'C263.2,133.3,263.1,133.3,263.1,133.3L263.1,133.3z"/>',
'</svg>'].join('\n')
/* eslint-enable */

export default {
  async mounted () {
    await this.init()
    this.map = this.initMap(document.getElementById('neighborhood-map'), 10)
  },
  components: {
    VDaySelector,
    schools,
    neighborhood,
    propertyDetails,
    taxHistory,
    openHouses,
    propertyHistory,
    disclosures,
    schedule,
    question,
    factSheet,
    terms,
    imageModal,
    mapModal,
    SaveButton,
    HouseTag,
    ShareModal,
    AuthModal,
    HouseSuggestionDropdown,
    ClaimModal,
    HomeProfileTabs
  },
  data () {
    return {
      selectedImage: 0,
      populated: false,
      house: null,
      searchString: null,
      map: null,
      marker: null,
      propertyCollapse: false,
      openHousesCollapse: false,
      taxHistoryCollapse: false,
      propertyHistoryCollapse: false,
      schoolsCollapse: false,
      neighborhoodCollapse: false,
      disclosureCollapse: false,
      currentHouse: null,
      previousRoute: null,
      suggestion: null,
      alertDismissSeconds: 3,
      alertDismissCountdown: 0
    }
  },
  computed: {
    ...mapGetters([
      'getIdProvider',
      'getSecretAccessKey'
    ]),
    ...mapGetters('user', [
      'getClaimedHouses'
    ]),
    ...mapGetters('homeSearch', [
      'getBedNumber',
      'getBathNumber',
      'getMinSqft',
      'getMaxSqft',
      'getMinPrice',
      'getMaxPrice',
      'getStories',
      'getHeatingCooling',
      'getGarage',
      'getMinHOA',
      'getMaxHOA'
    ]),
    houseClaimed () {
      if (this.house && this.house.id && this.getClaimedHouses && this.getClaimedHouses.indexOf(this.house.id) > -1) return true
      return false
    },
    addressPartOne () {
      let address1 = this.house.street_number + ' ' + this.house.street_name + ' ' + this.house.street_suffix
      if (this.house.unit_number) {
        address1 += ' Unit Number: #' + this.house.unit_number
      }
      return address1
    },
    addressPartTwo () {
      return this.house.city + ', ' + this.house.state + ' ' + this.house.zip_code
    },
    houseStatus () {
      if (this.house.special_circumstances === 'Rental') return 'R'
      if (this.house.special_circumstances === 'Foreclosure') return 'F'
      if (this.house.special_circumstances === 'Off Market') return 'O'
      if (this.house.special_circumstances === 'New Construction') return 'N'
      return ''
    },
    coverPhoto () {
      return 'background-image: url("' + this.house.signedPhotos.large[0] + '")'
    },
    endPath () {
      return this.$route.params.endPath
    },
    offMarket () {
      if (this.house.special_circumstances === 'Off Market') return true
      return false
    },
    shareData () {
      return {
        url: window.location.href,
        address: this.addressPartOne + '<br>' + this.addressPartTwo,
        photo_url: this.house.signedPhotos.large[0],
        ...(this.house.price && {price: this.house.price}),
        ...(this.house.bedroom_count && {beds: this.house.bedroom_count}),
        ...(this.house.bathroom_count && {baths: this.house.bathroom_count}),
        ...(this.house.house_sqft && {sqft: this.house.house_sqft})
      }
    }
  },
  methods: {
    ...mapActions([
      'unauthenticatedLogin'
    ]),
    alertCountdownChanged (countdownValue) {
      this.alertDismissCountdown = countdownValue
    },
    loginRequired () {
      this.$refs.authModal.$refs.authModal.show()
    },
    async performSuggestionSearch (suggestion) {
      this.suggestion = suggestion
      if ('unit_number' in suggestion) {
        let address = ''
        if ('street_name' in suggestion) { address += suggestion['street_name'] }
        if ('city' in suggestion) { address += ' ' + suggestion['city'] }
        this.searchString = address
      } else if ('zip_code' in suggestion) {
        this.searchString = suggestion.zip_code
      } else {
        this.searchString = suggestion.city
      }
      this.changeURL()
    },
    showClaimModal () {
      if (this.getIdProvider) {
        this.$refs.claimModal.$refs.claimModal.show()
      } else {
        this.$refs.authModal.$refs.authModal.show()
      }
    },
    copyURL () {
      // Solution from https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
      const el = document.createElement('textarea')
      el.value = window.location.href
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection.rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      console.log(this.alertDismissCountdown)
      this.alertDismissCountdown = this.alertDismissSeconds
      console.log(this.alertDismissCountdown)
    },
    showMapModal () {
      this.$refs.mapModal.$refs.mapModal.show()
    },
    showImageModal (index) {
      this.selectedImage = index
      this.$refs.imageModal.$refs.imageModal.show()
      this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    },
    async init () {
      try {
        this.searchString = this.$route.params.searchString
        this.house = new House(this.$route.params.id)
        await this.house.getHouse()
        if (this.house.price) this.populated = true
      } catch (error) {
        console.log(error)
      }
    },
    async changeURL (suggestion) {
      if (!this.getSecretAccessKey) {
        await this.unauthenticatedLogin()
      }
      router.push({
        path: '/propertysearch',
        query: {
          search: this.searchString,
          suggestion: JSON.stringify(this.suggestion),
          propertyType: this.getPropertyType,
          baths: this.getBathNumber,
          beds: this.getBedNumber,
          listingstatus: this.getListingStatus,
          listingoptions: this.getListingOptions,
          listingevents: this.getListingEvents,
          minsqft: this.getMinSqft,
          maxsqft: this.getMaxSqft,
          minprice: this.getMinPrice,
          maxprice: this.getMaxPrice,
          stories: this.getStories,
          insidefeatures: this.getInsideFeatures,
          outsidefeatures: this.getOutsideFeatures,
          hc: this.getHeatingCooling,
          parking: this.getParking,
          maxhomeage: this.getMaxHomeAge,
          minhomeage: this.getMinHomeAge,
          garage: this.getGarage,
          lotview: this.getLotView,
          communityamenities: this.getCommunityAmenities,
          minhoa: this.getMinHOA,
          maxhoa: this.getMaxHOA
        }
      }).catch((error) => {
        if (error.name !== 'NavigationDuplicated') {
          console.log(error)
        }
      })
    },
    initMap (node, zoom) {
      var map = new window.google.maps.Map(node, {
        mapTypeControlOptions: {
          mapTypeIds: [window.google.maps.MapTypeId.ROADMAP]
        },
        center: this.house.loc(),
        zoom: zoom,
        fullscreenControl: false,
        streetViewControl: false
      })
      this.marker = new window.google.maps.Marker({
        position: this.house.loc(),
        map: map,
        icon: {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(houseSVG),
          scaledSize: new window.google.maps.Size(40, 40)
        }
      })
      return map
    },
    async triggerSuggestions () {
      this.$refs.suggestionDropdown.triggerSuggestions(this.searchString)
    }
  },
  watch: {
    getSecretAccessKey: async function (newValue, oldValue) {
      if (oldValue === null && newValue !== null) {
        await this.init()
      }
    },
    // Ensure an address suggestion search into another address suggestion search loads in the new data
    '$route': function () {
      if (this.$route.params.id !== this.currentHouse) router.go()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.currentHouse = to.params.id
      vm.previousRoute = from.fullPath
    })
  }
}
</script>

<style scoped>
.address {
  font-size: 1.2rem;
}

.house-status {
  float: right;
  width: auto;
  padding-right: 1rem;
  font-size: 35px;
  font-family: 'Black Ops One', cursive !important;
}

.terms-row {
  padding-top: 3rem;
}

.fas {
  width: 30px;
}

#accordion-6 {
  margin-bottom: 2rem;
}

.accordion-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
}

.content-wrapper {
  margin-bottom: 1rem;
}

.full-wrapper {
  padding-top: 1rem;
}

.no-bottom-margin {
  margin-bottom: 0;
}

.small-col {
  padding-right: 0px !important;
}

.picture {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  cursor: pointer;
  position: relative;
}

@media (max-width: 992px) {
  .picture {
    min-height: 500px;
  }
}

.input-group, .form-group {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.container-responsive {
  margin-right: 1rem;
  margin-left: 1rem;
}

table {
  margin-bottom: 0;
}

.broker-logo {
  height: 20px !important;
}

td {
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 0;
}

.fa-arrow-down, .fa-arrow-up {
  margin-right: 1rem;
}

.card, card-img-top {
  box-shadow: None !important;
}

.card-columns {
  column-count: 3;
}

@media (max-width: 2000px) {
  .card-columns {
    column-count: 2;
  }
}

@media (max-width: 1300px) {
  .card-columns {
    column-count: 1;
  }
}

.card-img-top {
  cursor: pointer;
}

.map-container {
  padding-top: 0.5rem;
  height: auto;
  width: 100%;
}

#neighborhood-map {
  height: 100%;
  width: 100%;
}

.home-button {
  bottom: 0rem;
  position: absolute;
  right: 1rem;
  width: 2.5rem;
}

.no-space {
  padding: 0;
  margin: 0;
}

.save-button {
  padding-right: 0.5rem;
}

.share-button {
  padding-left: 0.5rem;
}

.homfax-title {
  text-indent: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/PropertySearch.vue